import React from 'react';
import {StyleSheet, Text, TouchableOpacity} from 'react-native';
import {Colors} from '../../../constants/Colors';

interface CatalogFullButtonProps {
  onPress: () => void;
}

const CatalogFullButton: React.FC<CatalogFullButtonProps> = ({onPress}) => {
  return (
    <TouchableOpacity style={styles.button} onPress={onPress} activeOpacity={0.8}>
      <Text style={styles.text}>Ver catálogo completo →</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    backgroundColor: Colors.RedPallete.red,
    marginHorizontal: 16,
    marginVertical: 16,
    paddingVertical: 14,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: '#FFFFFF',
    fontSize: 15,
    fontFamily: 'TCCC-UnityText Bold',
    fontWeight: 'bold',
  },
});

export default CatalogFullButton;
